export class LLLL {
  getOptions() {
    return {
      year: 'numeric',
      month: 'long',
      weekday: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    };
  }
}


/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/core/i18n/date/DayOfWeekMonthNameDayYearTime.js
 **/